module.exports = __webpack_public_path__ + "img/thumb_36.c0e82f0b.jpg";